import React from 'react';
import { QuoteForms } from './components/quote-forms';

const Quote = () => <QuoteForms />;

export default Quote;
